import FW from '../fw/fw';


export default class Logo {

  #rmp;
  #onLogoLoadFn = null;
  #onLogoErrorFn = null;
  #openLogoUrlFn = null;
  #logoImg = null;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  #onLogoLoad() {
    this.#logoImg.removeEventListener('load', this.#onLogoLoadFn);
    this.#logoImg.removeEventListener('error', this.#onLogoErrorFn);
    this.#rmp.dom.container.appendChild(this.#logoImg);
  }

  #onLogoError(event) {
    this.#logoImg.removeEventListener('load', this.#onLogoLoadFn);
    this.#logoImg.removeEventListener('error', this.#onLogoErrorFn);
    this.#rmp.rmpUtils.warning(1000, event);
    this.hide();
  }

  #openUrl(event) {
    if (event) {
      event.stopPropagation();
    }
    this.#rmp.rmpUIManagement.showChrome();
    if (event.type === 'touchend') {
      return;
    }
    const logoConfiguration = this.#rmp.logoConfiguration;
    if (logoConfiguration.clickUri !== '') {
      if (logoConfiguration.pauseContentOnLogoClick && !this.#rmp.paused) {
        this.#rmp.pause();
      }
      window.open(logoConfiguration.clickUri, '_blank');
      this.#rmp.dispatch('logoclick');
    }
  }

  #prepareLogoImg() {
    this.#logoImg.classList.remove(
      'rmp-logo',
      'rmp-force-show',
      'rmp-logo-bottom-left',
      'rmp-logo-top-right',
      'rmp-logo-bottom-right',
      'rmp-logo-top-left'
    );
    const logoConfiguration = this.#rmp.logoConfiguration;
    let logoClassName = 'rmp-logo';
    if (logoConfiguration.watermark) {
      logoClassName += ' rmp-force-show';
    }
    switch (logoConfiguration.position) {
      case 'bottomleft':
        logoClassName += ' rmp-logo-bottom-left';
        break;
      case 'topright':
        logoClassName += ' rmp-logo-top-right';
        break;
      case 'bottomright':
        logoClassName += ' rmp-logo-bottom-right';
        break;
      // 'topleft' default
      default:
        logoClassName += ' rmp-logo-top-left';
        break;
    }
    this.#logoImg.className = logoClassName;
    if (logoConfiguration.margin !== '8px') {
      this.#logoImg.style.margin = logoConfiguration.margin;
    }
  }

  filter() {
    if (this.#rmp.logo.imgUri && typeof this.#rmp.logo.imgUri !== 'string') {
      this.#rmp.logo.imgUri = '';
    }
    if (this.#rmp.logo.clickUri && typeof this.#rmp.logo.clickUri !== 'string') {
      this.#rmp.logo.clickUri = '';
    }
    const logoPositionArray = ['topleft', 'bottomleft', 'topright', 'bottomright'];
    if (this.#rmp.logo.position && !logoPositionArray.includes(this.#rmp.logo.position)) {
      this.#rmp.logo.position = 'topleft';
    }
    if (typeof this.#rmp.logo.watermark !== 'boolean') {
      this.#rmp.logo.watermark = false;
    }
    if (typeof this.#rmp.logo.pauseContentOnLogoClick !== 'boolean') {
      this.#rmp.logo.pauseContentOnLogoClick = true;
    }
    if (typeof this.#rmp.logo.margin !== 'string') {
      this.#rmp.logo.margin = '8px';
    }
  }

  hide() {
    FW.hide(this.#logoImg);
  }

  show() {
    FW.show(this.#logoImg);
  }

  init() {
    this.#logoImg = document.createElement('img');
    this.#logoImg.alt = '';
    this.#prepareLogoImg();
    this.#onLogoLoadFn = this.#onLogoLoad.bind(this);
    this.#onLogoErrorFn = this.#onLogoError.bind(this);
    this.#logoImg.addEventListener('load', this.#onLogoLoadFn);
    this.#logoImg.addEventListener('error', this.#onLogoErrorFn);
    this.#openLogoUrlFn = this.#openUrl.bind(this);
    FW.addEvents(['touchend', 'click'], this.#logoImg, this.#openLogoUrlFn);
    this.#logoImg.src = this.#rmp.logoConfiguration.imgUri;
  }

  update() {
    this.#prepareLogoImg();
    this.#logoImg.addEventListener('error', this.#onLogoErrorFn);
    this.#logoImg.src = this.#rmp.logoConfiguration.imgUri;
  }
}
